<template>
    <div class="land-genplan">
        <div class="section-title-mobile" v-if="isMobileChecker">
            <div class="pic-title-bg" :style="'background-image: url(' + salesCard.genplan_section_title_img + ')'"></div>
            <h2 v-if="projectNameG == 'duman'" v-html="salesCard.genplan_title_mobile"></h2>
            <h2 v-else v-html="salesCard.genplan_title"></h2>
        </div>
        <div class="container">
            <div class="land-genplan-column-container" :class="'land-genplan-' + projectNameG">
                <div class="col-left">
                    <div class="column-info">
                        <div class="section-title" v-if="!isMobileChecker">
                            <h2>{{salesCard.genplan_title}}</h2>
                        </div>
                        <div class="desc-html" v-html="salesCard.genplan_desc"></div>
                    </div>
                </div>
                <div class="col-right">
                    <div class="genplan-title-mobile" v-if="projectNameG == 'duman' && isMobileChecker && salesCard.genplan_map_title != null && salesCard.genplan_map_title != ''"><h2>{{ salesCard.genplan_map_title }}</h2></div>
                    <div class="col-img">
                        <img :src="salesCard.genplan_img" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-genplan',
        components: {
        },
        data () {
            return {
                lang: window.GlobalLang,
                projectNameG: window.host,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-genplan.scss';
    @import '@/styles/components/sales/respond/land-genplan-respond.scss';
</style>